import { get, post, put } from "aws-amplify/api";

const RestAPI = {
    /**
   * @param apiName {String}
   * @param path {String}
   * @param options {Parameters<typeof get>[0]["options"]}
   * */
    get: async (apiName, path, options) => (
        await get({ apiName, path, options }).response
    ).body.json(),
    /**
   * @param apiName {String}
   * @param path {String}
   * @param options {Parameters<typeof post>[0]["options"]}
   * */
    post: async (apiName, path, options) => (
        await post({ apiName, path, options }).response
    ).body.json(),
    /**
   * @param apiName {String}
   * @param path {String}
   * @param options {Parameters<typeof put>[0]["options"]}
   * */
    put: async (apiName, path, options) => (
        await put({ apiName, path, options }).response
    ).body.json()
};

/**
 * Extrae el status HTTP de un error de amplify/api.
 * Amplify expone el status de distintas formas segun la version/envoltorio
 * (response.status, response.statusCode, _response.statusCode, statusCode, $metadata.httpStatusCode),
 * por lo que se contemplan todas.
 * @param error {unknown}
 * @returns {number | undefined}
 */
const getErrorStatus = (error) => (
    error?.response?.status
        ?? error?.response?.statusCode
        ?? error?._response?.statusCode
        ?? error?.statusCode
        ?? error?.$metadata?.httpStatusCode
);

/**
 * Indica si un error corresponde a un status HTTP dado.
 * @param error {unknown}
 * @param status {number}
 * @returns {boolean}
 */
const isHttpStatus = (error, status) => getErrorStatus(error) === status;

/**
 * Indica si un error corresponde a un 401 (Unauthorized).
 * @param error {unknown}
 * @returns {boolean}
 */
const isUnauthorized = (error) => isHttpStatus(error, 401);

export { RestAPI, getErrorStatus, isHttpStatus, isUnauthorized };
